const Logo = (props) => <img alt="Logo" src="/static/logo-full-v3.svg" height={50} {...props} />;

export default Logo;
